import { defineMessages } from "react-intl";

export default defineMessages({
  kickOff: {
    id: "MatchSummaryCard.kickOff",
    defaultMessage: "Kick off",
  },
  own: {
    id: "MatchSummaryCard.Own",
    defaultMessage: "Own",
  },
  goal: {
    id: "MatchSummaryCard.Goal",
    defaultMessage: "Goal",
  },
  prepareGame: {
    id: "MatchSummaryCard.prepareGame",
    defaultMessage: "Prepare game",
  },
  viewGame: {
    id: "MatchSummaryCard.viewGame",
    defaultMessage: "View game",
  },
  playersSelected: {
    id: "MatchSummaryCard.playersSelected",
    defaultMessage: "Players selected",
  },
  playersConfirmed: {
    id: "MatchSummaryCard.playersConfirmed",
    defaultMessage: "Players confirmed",
  },
  location: {
    id: "MatchSummaryCard.location",
    defaultMessage: "Location",
  },
  friendly: {
    id: "MatchSummaryCard.friendly",
    defaultMessage: "Friendly",
  },
  league: {
    id: "MatchSummaryCard.league",
    defaultMessage: "League",
  },
  pending: {
    id: "MatchSummaryCard.pending",
    defaultMessage: "Pending",
  },
  home: {
    id: "MatchSummaryCard.home",
    defaultMessage: "H",
  },
  away: {
    id: "MatchSummaryCard.away",
    defaultMessage: "A",
  },
  confirmed: {
    id: "MatchSummaryCard.confirmed",
    defaultMessage: "{n} confirmed",
  },
  ownGoal: {
    id: "MatchSummaryCard.ownGoal",
    defaultMessage: `{n, plural,
      one {1 own goal}
      other {{n} own goals}
    }`,
  },
});
